import { render, staticRenderFns } from "./TravelPremium.vue?vue&type=template&id=5bf73800&"
import script from "./TravelPremium.vue?vue&type=script&lang=js&"
export * from "./TravelPremium.vue?vue&type=script&lang=js&"
import style0 from "./TravelPremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelPremium.vue"
export default component.exports